<form #modifyForm="ngForm" (ngSubmit)="onSubmit()">
  <h2 mat-dialog-title>Modify Share</h2>

      <mat-dialog-content>

        <mat-form-field>
            <mat-label>Code</mat-label>
            <input matInput type="text" [(ngModel)]="share.code" name="share.code" required readonly>
        </mat-form-field>
        &nbsp;&nbsp;
        <mat-form-field>
            <mat-label>Alias</mat-label>
            <input matInput type="text" [(ngModel)]="share.alias" name="share.alias" required>
        </mat-form-field>

        <mat-divider></mat-divider>

        <mat-form-field>
            <mat-label>Company</mat-label>
            <mat-select #company [ngModel]="share.company" name="share.company" required>
              <mat-option *ngFor="let c of companies;" value="{{c.code}}">{{c.name}}</mat-option>
            </mat-select>
        </mat-form-field>
        &nbsp;&nbsp;
        <mat-form-field>
            <mat-label>Type</mat-label>
            <mat-select #company [(ngModel)]="share.type" name="share.type" required>
              <mat-option value="FIXED">Fixed-income</mat-option>
              <mat-option value="REIT">Reit</mat-option>
              <mat-option value="STOCK">Stock</mat-option>
              <mat-option value="CRYPTO">Crypto</mat-option>
            </mat-select>
        </mat-form-field>

        <section>
            <mat-checkbox [(ngModel)]="share.dividends" name="share.dividends">Pays dividends</mat-checkbox>
        </section>

        <mat-divider></mat-divider>

        <mat-form-field style="width: 100%;">
          <mat-label>Site</mat-label>
          <input matInput type="text" [(ngModel)]="share.site" name="share.site" required>
        </mat-form-field>
    
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-raised-button type="submit" [disabled]="modifyForm.invalid">Save</button>
        <button mat-raised-button type="button" mat-dialog-close>Cancel</button>
      </mat-dialog-actions>

    <!-- <mat-card-footer>
      <p *ngIf="errorMessage" class="error">{{ errorMessage }}</p>
    </mat-card-footer> -->

</form>
